import { useEffect, useState } from "react";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import api from "../lib/api";
import { resolveIcon } from "./IconPicker";
import { ArrowUpRight, Stack } from "@phosphor-icons/react";

export default function SearchCommand({ open, onOpenChange, onSelectTile, onSelectDeck }) {
  const [q, setQ] = useState("");
  const [tiles, setTiles] = useState([]);
  const [decks, setDecks] = useState([]);

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(async () => {
      if (q.trim().length === 0) {
        // Show all tiles for empty query
        try {
          const { data } = await api.get(`/search?q=${encodeURIComponent(" ")}`);
          setTiles(data.tiles || []);
          setDecks(data.decks || []);
        } catch {
          setTiles([]);
          setDecks([]);
        }
        return;
      }
      try {
        const { data } = await api.get(`/search?q=${encodeURIComponent(q)}`);
        setTiles(data.tiles || []);
        setDecks(data.decks || []);
      } catch {
        setTiles([]);
        setDecks([]);
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [q, open]);

  return (
    <CommandDialog
      open={open}
      onOpenChange={onOpenChange}
      data-testid="search-dialog"
      className="bg-deck-sidebar border border-white/10 text-white"
    >
      <CommandInput
        data-testid="search-input"
        placeholder="Busca apps, links, plataformas..."
        value={q}
        onValueChange={setQ}
        className="text-white"
      />
      <CommandList className="text-white">
        <CommandEmpty className="py-8 text-center text-white/50 font-mono text-xs">
          Sin resultados
        </CommandEmpty>
        {decks.length > 0 && (
          <CommandGroup heading="Plataformas">
            {decks.map((deck) => {
              const Icon = resolveIcon(deck.icon);
              return (
                <CommandItem
                  key={deck.deck_id}
                  data-testid={`search-deck-${deck.deck_id}`}
                  value={`deck-${deck.name}-${deck.deck_id}`}
                  onSelect={() => {
                    onSelectDeck(deck);
                    onOpenChange(false);
                  }}
                  className="text-white aria-selected:bg-white/10"
                >
                  <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center mr-3"
                    style={{ backgroundColor: deck.color }}
                  >
                    <Icon size={16} weight="fill" className="text-white" />
                  </div>
                  <span className="font-heading font-semibold">{deck.name}</span>
                  <span className="ml-auto text-[10px] font-mono text-white/40 uppercase tracking-wider">
                    Plataforma
                  </span>
                </CommandItem>
              );
            })}
          </CommandGroup>
        )}
        {tiles.length > 0 && (
          <CommandGroup heading="Botones">
            {tiles.map((tile) => {
              const Icon = resolveIcon(tile.icon);
              return (
                <CommandItem
                  key={tile.tile_id}
                  data-testid={`search-tile-${tile.tile_id}`}
                  value={`tile-${tile.name}-${tile.url}-${tile.tile_id}`}
                  onSelect={() => {
                    onSelectTile(tile);
                    onOpenChange(false);
                  }}
                  className="text-white aria-selected:bg-white/10"
                >
                  <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center mr-3"
                    style={{ backgroundColor: tile.color, color: tile.text_color }}
                  >
                    {tile.image_url ? (
                      <img src={tile.image_url} alt="" className="w-5 h-5 object-contain" />
                    ) : (
                      <Icon size={16} weight="fill" />
                    )}
                  </div>
                  <div className="flex flex-col min-w-0">
                    <span className="font-heading font-semibold truncate">{tile.name}</span>
                    <span className="text-[10px] font-mono text-white/40 truncate">
                      {tile.url}
                    </span>
                  </div>
                  <ArrowUpRight size={14} weight="bold" className="ml-auto text-white/40" />
                </CommandItem>
              );
            })}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
